
export enum Status  {
   Disabled=0,
   Active=1,
   OutOfStock=2,


}